import { z } from '@hono/zod-openapi'
import { qrcodesTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export const zSelectQrcode = createSelectSchema(qrcodesTable)

export const zInsertQrcode = createInsertSchema(qrcodesTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})

export const zUpdateQrcode = zInsertQrcode.partial()

export const zQueryQrcode = zInsertQrcode
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()

export type SelectQrcode = z.infer<typeof zSelectQrcode>
export type InsertQrcode = z.infer<typeof zInsertQrcode>
export type UpdateQrcode = z.infer<typeof zUpdateQrcode>
export type QueryQrcode = z.infer<typeof zQueryQrcode>
export type ColumnsOfQrcodeTable = keyof typeof qrcodesTable._.columns
